import React from 'react';
import Navbar from '../components/common/Navbar';
import Footer from '../components/common/Footer';
import './AboutPage.css';

const SOCIAL = [
  {
    href: 'https://www.instagram.com/vtd.astrology?igsh=NHZxd3p1MmRoMncz',
    label: 'Instagram',
    cls: 'about-social--ig',
    icon: <IGIcon />,
    name: '@vtd.astrology',
  },
  {
    href: 'https://www.facebook.com/share/1EH2UqAzWm/',
    label: 'Facebook',
    cls: 'about-social--fb',
    icon: <FBIcon />,
    name: 'VTD Astrology',
  },
  {
    href: '/chat',
    label: 'Chat',
    cls: 'about-social--wa',
    icon: <WAIcon />,
    name: 'Chat with Us',
  },
];

const DIFF_POINTS = [
  {
    icon: <ScienceIcon />,
    title: 'Scientific + Spiritual Approach',
    desc: 'Engineering mindset applied to ancient Vedic science. Every prediction is backed by chart analysis, not intuition alone.',
  },
  {
    icon: <LineageIcon />,
    title: 'Family Lineage — 3+ Generations',
    desc: 'Not self-taught. Tilak was born into a family of astrologers and Tantrik practitioners. This knowledge was passed down, not picked up.',
  },
  {
    icon: <EngineerIcon />,
    title: 'NIT Engineer Turned Astrologer',
    desc: 'The analytical rigour of an engineer combined with the spiritual depth of a Vedic scholar. A rare combination in this field.',
  },
  {
    icon: <RemedyIcon />,
    title: 'Personal Remedy Crafting',
    desc: 'Every remedy — mantra, gemstone, ritual — is personally designed by Tilak for your exact planetary position. Zero delegation.',
  },
  {
    icon: <CertIcon />,
    title: 'VTD Certified Team Standard',
    desc: 'Every astrologer on the VTD platform is personally trained and certified by Tilak. No random practitioners. Ever.',
  },
];

const AboutPage = () => (
  <div className="about-pg">
    <Navbar />
    <main>

      {/* ── SECTION 1: Hero ── */}
      <section className="about-hero">
        <div className="about-hero__inner">
          <p className="section-eyebrow">Our Story</p>
          <h1 className="about-hero__title">Vision Towards Destiny</h1>
          <p className="about-hero__sub">The story of VTD Astrology</p>
          <div className="gold-divider" style={{ maxWidth: 200, margin: '1.5rem auto 0' }} />
        </div>
      </section>

      {/* ── SECTION 2: Full Story ── */}
      <section className="about-story">
        <div className="about-story__inner">

          <div className="about-story__photo-col">
            <div className="about-story__photo">
              <img src="/images/tilak.jpg" alt="Tilak, Founder VTD Astrology"
                className="about-story__photo-img" />
            </div>
            <div className="about-story__photo-caption">
              <span className="about-story__name">Tilak</span>
              <span className="about-story__role">Founder &amp; CEO, VTD Astrology</span>
            </div>
          </div>

          <div className="about-story__text-col">

            <StorySection label="The Beginning">
              <p>My journey into Vedic astrology did not begin in a classroom. It began at home,
              watching my father Chandramouli — a respected Tantrik and Mantra Shastra expert —
              decode the mysteries of existence through ancient scriptures and sacred practices.</p>
              <p>My forefathers were devoted to this sacred science for generations. This was not
              a hobby in our family. This was dharma.</p>
            </StorySection>

            <StorySection label="The Decision">
              <p>When I was pursuing MCA at NIT Kurukshetra — one of India's most prestigious
              institutions — I made a decision that surprised everyone around me. I left.</p>
              <p>Not because I could not handle the academics. But because I realized that the
              degree I was chasing would never give me the purpose I was born with. The pull of
              astrology was too strong to ignore.</p>
            </StorySection>

            <StorySection label="The Mission">
              <p>I spent years studying under senior astrologers across Andhra Pradesh and Telangana,
              mastering Parashari, Jaimini, and Nadi traditions. I went deep into remedies —
              gemstones, mantras, yantras, homams — not as rituals but as scientific tools to
              shift planetary energies.</p>
              <p>My approach is different. I am not a spiritual entertainer. I am a practical
              problem-solver who uses the oldest software in the world — Vedic astrology — to
              help people navigate their lives with clarity and confidence.</p>
            </StorySection>

            <StorySection label="VTD's Promise">
              <p>VTD Astrology was built on one promise: accuracy over entertainment.</p>
              <p>Every prediction we give is backed by deep chart analysis. Every remedy we
              prescribe is personally designed. Every session you have with our team follows
              the VTD standard — trained, certified, and accountable.</p>
              <p>We do not believe in per-minute billing that rushes you. We do not believe in
              random astrologers who give you what you want to hear. We believe in honest,
              specific, life-changing Vedic guidance.</p>
            </StorySection>

          </div>
        </div>
      </section>

      {/* ── SECTION 3: Father's Legacy ── */}
      <section className="about-legacy">
        <div className="about-legacy__inner">
          <p className="section-eyebrow">Family Lineage</p>
          <h2 className="about-legacy__title">Standing on the Shoulders of Legends</h2>
          <div className="gold-divider" style={{ maxWidth: 160, margin: '1.25rem auto' }} />
          <div className="about-legacy__content">
            <div className="about-legacy__card">
              <div className="about-legacy__icon" aria-hidden="true">🏛️</div>
              <h3>Chandramouli</h3>
              <p className="about-legacy__sub">Tilak's Father</p>
              <p className="about-legacy__desc">
                A deeply respected expert in Tantrik and Mantra Shastra. Chandramouli has dedicated
                his life to the ancient sacred sciences — from Vedic ritual practice to the deeper
                mysteries of mantra energy and planetary propitiation.
              </p>
            </div>
            <div className="about-legacy__card">
              <div className="about-legacy__icon" aria-hidden="true">📜</div>
              <h3>3+ Generations</h3>
              <p className="about-legacy__sub">Of Sacred Practice</p>
              <p className="about-legacy__desc">
                This knowledge was not learned in a weekend course. It was transmitted across
                generations — from grandfather to father to son. This lineage shapes every remedy
                Tilak prescribes and every consultation he delivers.
              </p>
            </div>
            <div className="about-legacy__card">
              <div className="about-legacy__icon" aria-hidden="true">🌿</div>
              <h3>Living Remedies</h3>
              <p className="about-legacy__sub">Not Textbook Solutions</p>
              <p className="about-legacy__desc">
                The remedy tradition at VTD is rooted in lived practice — not copied from books.
                This is what makes VTD's remedy work different. It carries the weight and precision
                of a tradition that has been refined for over three generations.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ── SECTION 4: What Makes VTD Different ── */}
      <section className="about-diff">
        <div className="about-diff__inner">
          <p className="section-eyebrow">Why VTD</p>
          <h2 className="about-diff__title">What Makes VTD Different</h2>
          <div className="gold-divider" style={{ maxWidth: 160, margin: '1.25rem auto 2.5rem' }} />
          <div className="about-diff__grid">
            {DIFF_POINTS.map((p) => (
              <div key={p.title} className="about-diff__item">
                <div className="about-diff__item-icon">{p.icon}</div>
                <div>
                  <h3 className="about-diff__item-title">{p.title}</h3>
                  <p className="about-diff__item-desc">{p.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── SECTION 5: VTD Certified Program ── */}
      <section className="about-certified">
        <div className="about-certified__inner">
          <div className="about-certified__badge" aria-hidden="true">
            <CertBadgeIcon />
          </div>
          <h2 className="about-certified__title">The VTD Certified Standard</h2>
          <p className="about-certified__body">
            Every astrologer on the VTD platform is personally trained and certified by Tilak.
            We do not allow random practitioners. Our standard is high because your life matters.
          </p>
          <ul className="about-certified__list">
            <li>Minimum 6-month supervised training under Tilak</li>
            <li>Examination on Parashari, Jaimini &amp; Nadi systems</li>
            <li>Remedy knowledge certification</li>
            <li>Quality checks on 50 predictions before independent practice</li>
            <li>Ongoing supervision and performance reviews</li>
          </ul>
        </div>
      </section>

      {/* ── SECTION 6: CTA ── */}
      <section className="about-cta">
        <div className="about-cta__inner">
          <h2 className="about-cta__title">Ready to Experience the VTD Difference?</h2>
          <p className="about-cta__sub">
            Join 1000+ people who found clarity, direction and peace through VTD Astrology.
          </p>
          <a href="/chat" className="about-cta__btn">
            <WAIcon /> Book Your Session →
          </a>
          <div className="about-cta__social">
            {SOCIAL.map((s) => (
              <a key={s.label} href={s.href} className={`about-social-link ${s.cls}`}
                target="_blank" rel="noopener noreferrer" aria-label={s.label}>
                {s.icon}
                <span>{s.name}</span>
              </a>
            ))}
          </div>
        </div>
      </section>

    </main>
    <Footer />
  </div>
);

/* ── Sub-components ── */
const StorySection = ({ label, children }) => (
  <div className="story-block">
    <h3 className="story-block__label">{label}</h3>
    <div className="story-block__body">{children}</div>
  </div>
);

/* ── Icons ── */
function ScienceIcon() {
  return <svg viewBox="0 0 40 40" width="36" height="36" fill="none" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round"><circle cx="20" cy="20" r="14"/><line x1="20" y1="8" x2="20" y2="14"/><line x1="20" y1="26" x2="20" y2="32"/><line x1="8" y1="20" x2="14" y2="20"/><line x1="26" y1="20" x2="32" y2="20"/><circle cx="20" cy="20" r="4" fill="rgba(212,175,55,0.2)"/></svg>;
}
function LineageIcon() {
  return <svg viewBox="0 0 40 40" width="36" height="36" fill="none" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round"><circle cx="20" cy="10" r="4"/><circle cx="10" cy="30" r="4"/><circle cx="30" cy="30" r="4"/><line x1="20" y1="14" x2="10" y2="26"/><line x1="20" y1="14" x2="30" y2="26"/></svg>;
}
function EngineerIcon() {
  return <svg viewBox="0 0 40 40" width="36" height="36" fill="none" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round"><rect x="8" y="14" width="24" height="18" rx="2"/><path d="M14 14 V10 Q14 6 20 6 Q26 6 26 10 V14"/><line x1="15" y1="23" x2="25" y2="23"/><line x1="15" y1="27" x2="21" y2="27"/></svg>;
}
function RemedyIcon() {
  return <svg viewBox="0 0 40 40" width="36" height="36" fill="none" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round"><path d="M20 4 L23 14 L34 14 L25 20 L28 32 L20 26 L12 32 L15 20 L6 14 L17 14 Z"/><circle cx="20" cy="20" r="3" fill="#FFD700" opacity="0.7" stroke="none"/></svg>;
}
function CertIcon() {
  return <svg viewBox="0 0 40 40" width="36" height="36" fill="none" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round"><path d="M20 4 L24 13 L34 13 L26 19 L29 30 L20 24 L11 30 L14 19 L6 13 L16 13 Z"/><circle cx="20" cy="20" r="5" stroke="#FFD700" strokeWidth="1.5"/></svg>;
}
function CertBadgeIcon() {
  return <svg viewBox="0 0 80 80" width="72" height="72" fill="none" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round"><path d="M40 6 L47 26 L68 26 L51 38 L58 60 L40 48 L22 60 L29 38 L12 26 L33 26 Z"/><circle cx="40" cy="38" r="10" stroke="#FFD700" strokeWidth="1.8"/><path d="M34 38 L38 42 L46 34" stroke="#FFD700" strokeWidth="2.5"/></svg>;
}
function IGIcon() {
  return <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" stroke="none"/></svg>;
}
function FBIcon() {
  return <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>;
}
function WAIcon() {
  return <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>;
}

export default AboutPage;
